import { initFadeIn } from "./namespace/fadeIn";
import { initInterviewAccordion } from "./namespace/interviewAccordion";
import { initTocObserver } from "./namespace/tocObserver";

document.addEventListener("DOMContentLoaded", () => {
  initFadeIn();
  initInterviewAccordion();
  initTocObserver();
});
